import { decimalInput, domain } from "./domain";
import type { Blend } from "./types";
export interface ClientBlend {
  loans: number; pricedLoans: number; volume: number; pricedVolume: number;
  revenue: number; blendedRevPct: number | null; blendedPrice: number | null;
}
export function blend(items: Iterable<{ amount: string | number | null; price: string | number | null }>): ClientBlend {
  const b = domain<Blend>({ kind: "blend", items: [...items].map((i) => [decimalInput(i.amount), decimalInput(i.price)]) });
  return { loans: b.loans, pricedLoans: b.priced_loans, volume: Number(b.volume), pricedVolume: Number(b.priced_volume), revenue: Number(b.revenue),
    blendedRevPct: b.blended_rev_pct === null ? null : Number(b.blended_rev_pct), blendedPrice: b.blended_price === null ? null : Number(b.blended_price) };
}
export function revenue(amount: string | number | null, price: string | number | null): number | null {
  const r = domain<string | null>({ kind: "revenue", amount: decimalInput(amount), price: decimalInput(price) });
  return r === null ? null : Number(r);
}
